/* Step 12 add-on G (lane GA, PR "Step 12-F2") — EN + AR of
   G1 318(a) "Opinion type concluded" read from the Audit summary memo (W10), read-only, "Edit in the summary memo";
   G3 the reporting framework on the create-engagement form (optional; not chosen = today's default);
   G4 / G1 / G3 the Audit Trail rows of this add-on (action labels and their detail);
   G5 a label for every W9 source kind (no raw key such as "cutoff" on W9).
   No standard paragraph is quoted. */
const I18N_S12F2 = {
  en: {
    w9: {
      sourceLabels: {
        cutoff: "Cut-off test",
        cutoff_post_year_end: "Cut-off test — after year end",
        unrecorded_liability: "Unrecorded liabilities",
        opening_balance: "Opening balances",
        manual: "Entered manually",
        aging: "Aging",
        related_party: "Related party",
        completeness: "Completeness",
        estimate: "Estimate",
        observation: "Observation",
        discrepancy: "Discrepancy",
        sample_projection: "Sampling — best estimate",
      },
      sourceOther: "Worksheet",
    },
    s12f2: {
      op: {
        readOnly: "Read from the Audit summary memo (W10) — the memo holds the opinion type.",
        edit: "Edit in the summary memo",
        blank: "Not chosen in the summary memo yet",
      },
      rf: {
        optional: "Optional — not chosen: set it later in Engagement settings.",
        notChosen: "Not chosen",
      },
      isqm: { eqrRequired: "where an engagement quality review is required" },
      audit: {
        was: "(was {was})",
        framework: "— {fw}",
        rows: "({n} row(s))",
      },
    },
    w13: {
      action: {
        opinion_read_from_w10: "318(a) opinion now read from W10",
        reporting_framework_set: "Reporting framework set",
        misstatement_rows_unlinked: "Worksheet rows freed (misstatement deleted)",
        misstatement_rows_relinked: "Worksheet rows linked again (misstatement restored)",
        misstatement_row_freed: "Worksheet row freed (its misstatement was deleted or is missing)",
      },
    },
  },
  ar: {
    w9: {
      sourceLabels: {
        cutoff: "اختبار القطع",
        cutoff_post_year_end: "اختبار القطع — بعد نهاية السنة",
        unrecorded_liability: "الالتزامات غير المسجلة",
        opening_balance: "الأرصدة الافتتاحية",
        manual: "مُدخل يدوياً",
        aging: "تحليل الأعمار",
        related_party: "الأطراف ذات العلاقة",
        completeness: "الاكتمال",
        estimate: "التقدير",
        observation: "الملاحظة",
        discrepancy: "التباين",
        sample_projection: "المعاينة — أفضل تقدير",
      },
      sourceOther: "ورقة عمل",
    },
    s12f2: {
      op: {
        readOnly: "يُقرأ من مذكرة ملخص المراجعة (W10) — المذكرة هي التي تحفظ نوع الرأي.",
        edit: "عدّل في مذكرة الملخص",
        blank: "لم يُختر في مذكرة الملخص بعد",
      },
      rf: {
        optional: "اختياري — إن لم يُختر: يُحدَّد لاحقاً في إعدادات الارتباط.",
        notChosen: "غير محدد",
      },
      isqm: { eqrRequired: "عندما تكون مراجعة جودة الارتباط مطلوبة" },
      audit: {
        was: "(كان {was})",
        framework: "— {fw}",
        rows: "({n} صف)",
      },
    },
    w13: {
      action: {
        opinion_read_from_w10: "رأي 318(a) يُقرأ الآن من W10",
        reporting_framework_set: "تم تحديد إطار التقرير المالي",
        misstatement_rows_unlinked: "تحرير صفوف ورقة العمل (حُذف التحريف)",
        misstatement_rows_relinked: "إعادة ربط صفوف ورقة العمل (استُعيد التحريف)",
        misstatement_row_freed: "تحرير صف ورقة العمل (تحريفه محذوف أو غير موجود)",
      },
    },
  },
};

export default I18N_S12F2;
